import { Component } from '@angular/core';
import {animate, style, transition, trigger} from '@angular/animations';
import { DisplayError, ErrorService } from '../../services/error.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({height: '0'}),
        animate('300ms', style({height: '*'}))
      ]),
      transition(':leave', [
        animate('200ms', style({height: '0'}))
      ])
    ])
  ]
})
export class ErrorComponent {

  constructor(
    public errorService: ErrorService,
  ) { }

  trackByFn(index: number, item: DisplayError): string {
    return item.msgKey;
  }

}
